var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.objData.repType === "image"
    ? _c("div", [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticClass: "waterfall",
          },
          _vm._l(_vm.tableData, function (item) {
            return _c(
              "div",
              { key: item.mediaId, staticClass: "waterfall-item" },
              [
                _c("img", {
                  staticClass: "material-img",
                  attrs: { src: item.url },
                }),
                _c("p", { staticClass: "item-name" }, [
                  _vm._v(_vm._s(item.name)),
                ]),
                _c(
                  "el-row",
                  { staticClass: "ope-row" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "success" },
                        on: {
                          click: function ($event) {
                            return _vm.selectMaterial(item, _vm.objData.appId)
                          },
                        },
                      },
                      [
                        _vm._v("选择"),
                        _c("i", {
                          staticClass: "el-icon-circle-check el-icon--right",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          0
        ),
        _vm.tableData.length <= 0 && !_vm.tableLoading
          ? _c("div", { staticClass: "el-table__empty-block" }, [
              _c("span", { staticClass: "el-table__empty-text" }, [
                _vm._v("暂无数据"),
              ]),
            ])
          : _vm._e(),
        _c(
          "span",
          {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          },
          [
            _c("el-pagination", {
              staticClass: "pagination",
              attrs: {
                "current-page": _vm.page.currentPage,
                "page-sizes": [10, 20],
                "page-size": _vm.page.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.page.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
              },
            }),
          ],
          1
        ),
      ])
    : _vm.objData.repType === "voice"
    ? _c(
        "div",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOptionVoice,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getPage,
              "size-change": _vm.sizeChange,
              "refresh-change": _vm.refreshChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-circle-plus",
                          size: "small",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectMaterial(
                              scope.row,
                              _vm.objData.appId
                            )
                          },
                        },
                      },
                      [_vm._v("选择")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      )
    : _vm.objData.repType === "video"
    ? _c(
        "div",
        [
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOptionVideo,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getPage,
              "size-change": _vm.sizeChange,
              "refresh-change": _vm.refreshChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menu",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          icon: "el-icon-circle-plus",
                          size: "small",
                          plain: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectMaterial(
                              scope.row,
                              _vm.objData.appId
                            )
                          },
                        },
                      },
                      [_vm._v("选择")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      )
    : _vm.objData.repType === "news"
    ? _c("div", [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.tableLoading,
                expression: "tableLoading",
              },
            ],
            staticClass: "waterfall",
          },
          _vm._l(_vm.tableData, function (item) {
            return item.content && item.content.newsItem
              ? _c(
                  "div",
                  { key: item.mediaId, staticClass: "waterfall-item" },
                  [
                    _c("WxNews", {
                      attrs: { "obj-data": item.content.newsItem },
                    }),
                    _c(
                      "el-row",
                      { staticClass: "ope-row" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.selectMaterial(
                                  item,
                                  _vm.objData.appId
                                )
                              },
                            },
                          },
                          [
                            _vm._v("选择"),
                            _c("i", {
                              staticClass:
                                "el-icon-circle-check el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e()
          }),
          0
        ),
        _vm.tableData.length <= 0 && !_vm.tableLoading
          ? _c("div", { staticClass: "el-table__empty-block" }, [
              _c("span", { staticClass: "el-table__empty-text" }, [
                _vm._v("暂无数据"),
              ]),
            ])
          : _vm._e(),
        _c(
          "span",
          {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          },
          [
            _c("el-pagination", {
              staticClass: "pagination",
              attrs: {
                "current-page": _vm.page.currentPage,
                "page-sizes": [10, 20],
                "page-size": _vm.page.pageSize,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.page.total,
              },
              on: {
                "update:currentPage": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "update:current-page": function ($event) {
                  return _vm.$set(_vm.page, "currentPage", $event)
                },
                "size-change": _vm.sizeChange,
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }